import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotArrow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4923_21161)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M14 8.00004C14 8.92052 13.2538 9.66671 12.3333 9.66671C11.4129 9.66671 10.6667 8.92052 10.6667 8.00004C10.6667 7.07957 11.4129 6.33337 12.3333 6.33337C13.2538 6.33337 14 7.07957 14 8.00004Z",
			fill: "#363636"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2 8.00004H11.3333M14 8.00004C14 8.92052 13.2538 9.66671 12.3333 9.66671C11.4129 9.66671 10.6667 8.92052 10.6667 8.00004C10.6667 7.07957 11.4129 6.33337 12.3333 6.33337C13.2538 6.33337 14 7.07957 14 8.00004Z",
			stroke: "#363636"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4923_21161",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z",
			fill: "white"
		})
	}) })]
});
export default SvgDotArrow;
